import LoadingContainer from "./loadingContainer/loadingContainer";
import ToastContainer from './Toast/toastContainer';
import BreadCrumb from "./BreadCurmb/breadCrumb";
import SelectDropdown from "./SelectDropdown/selectDropdown";
import SearchBox from "./serachBox/searchBox";
import IconButton from "./NextButton/IconButton";
import TimeBox from './TimeBox/timeBox';
import ConfirmModal from "./ConfirmModal/confirmModal";
import StatusDropdown from "./StatusDropdown/statusDropdown";
import LanguageSwitcher from "./languageSwitcher/languageSwitcher";
import ToastPopup from "./Toast/toastPopup";
import Reject from "./rejectModal/reject";
import CountryCodeSelect from "./countryCodeSelect/countryCodeSelect";
import SelectCard from "./selectCard/selectCard";
import ProgressBar from "./ProgressBar/ProgressBar";
import ToggleSwitch from "./ToggleSwitch/ToggleSwitch";
import NewSelectDropdown from "./SelectDropdown/NewSelectDropdown";
import RejectEdit from "./rejectModal/rejectEdit";
import TextModal from "./TextModal/TextModal";
import FloatingInput from "./FloatingInput/FloatingInput";

const Widgets = {
    LoadingContainer,
    ToastContainer,
    BreadCrumb,
    SelectDropdown,
    SearchBox,
    IconButton,
    TimeBox,
    ConfirmModal,
    StatusDropdown,
    ToastPopup,
    LanguageSwitcher,
    Reject,
    FloatingInput,
    CountryCodeSelect,
    SelectCard,
    ProgressBar,
    ToggleSwitch,
    NewSelectDropdown,
    RejectEdit,
    TextModal
};

export default Widgets;